import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from './LoginModal';
import './AuthButton.css';

interface AuthButtonProps {
  onAuthSuccess?: () => void;
}

const AuthButton: FC<AuthButtonProps> = ({ onAuthSuccess }) => {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);

  if (isAuthenticated) {
    return null; // UserProfileDropdown will handle authenticated state
  }

  return (
    <>
      <button
        onClick={() => setShowLoginModal(true)}
        className="auth-button"
        disabled={isLoading}
      >
        {isLoading ? <span className="spinner"></span> : t('auth.signIn')}
      </button>

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onSuccess={() => {
          setShowLoginModal(false);
          onAuthSuccess?.();
        }}
      />
    </>
  );
};

export default AuthButton;
